// Merges the general Search Everywhere prompt list with the SoM prompt list
// (both fetched from the same existing GET /v2/prompts/{clientId} route, the
// second call passing prompt_type=som). General prompts are kept first, SoM
// prompts second; each group preserves the order the backend returned.
// Deduplicates by id only — prompt_text is never a safe dedup key since two
// distinct prompts can legitimately share the same text.
export function mergePrompts(generalPrompts, somPrompts) {
  const general = Array.isArray(generalPrompts) ? generalPrompts : [];
  const som = Array.isArray(somPrompts) ? somPrompts : [];
  const seen = new Set();
  const merged = [];
  for (const prompt of [...general, ...som]) {
    if (!prompt || !prompt.id || seen.has(prompt.id)) continue;
    seen.add(prompt.id);
    merged.push(prompt);
  }
  return merged;
}
